import { useCallback, useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { RequireAuth } from '~/components/auth/require-auth';
import { useExperience } from '~/hooks/use-experience';
import { DataStore } from '~/store';
import { PreventNavigation } from '~/hoc/prevent-navigation';
import { AssetDetail } from './detail';
import { AssetDetailExperienceFunds } from './detail-experience-funds';
import {
  BreadcrumbList,
  NavBar,
  useBreakpoints,
} from '@xbto/universal-components';
import { APP_ROUTES } from '~/routes';
import cx from 'classnames';

export const AssetPage = () => {
  const { id: currId } = useParams();
  const navigate = useNavigate();
  const { breakpoints } = useBreakpoints(500);

  const currencies = DataStore.useStoreState(s => s.metaData.currencies);
  const showFundsExperience = useExperience();

  const currency = useMemo(
    () => currencies.find(curr => curr.code === currId),
    [currId, currencies]
  );

  const validate = useCallback(() => {
    return !!currency;
  }, [currency]);

  // TODO(Hadrien): Merge with account-holding code, extract useNavbar hook
  const handlePressBack = useCallback(() => {
    navigate(-1);
  }, [navigate]);
  const goToMarkets = useCallback(() => {
    let assetType = currency?.isAssetOfTypeFund
      ? 'Funds'
      : currency?.isAssetOfTypeCrypto
        ? 'Crypto'
        : currency?.isAssetOfTypeFiat
          ? 'Fiat'
          : 'Bonds';
    navigate(`${APP_ROUTES.AUTH_MARKETS}?assetType=${assetType}`);
  }, [currency, navigate]);

  return (
    <RequireAuth>
      <PreventNavigation validate={validate}>
        <div className={cx(breakpoints.MORE_THAN_M ? 'block' : 'hidden')}>
          <NavBar onPressBack={handlePressBack}>
            <BreadcrumbList
              items={[
                { label: 'Markets', onPress: goToMarkets },
                { label: currency?.name || 'Asset' },
              ]}
            />
          </NavBar>
        </div>
        {showFundsExperience && currency?.isAssetOfTypeFund ? (
          <AssetDetailExperienceFunds currency={currency} />
        ) : (
          <AssetDetail />
        )}
      </PreventNavigation>
    </RequireAuth>
  );
};
